// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3dK5I","messages":"Chat_messages__1xVva","dateDivider":"Chat_dateDivider__1097X"};